var toUnsigned = function toUnsigned(value) {
  return value >>> 0;
};
module.exports = {
  toUnsigned: toUnsigned
};